class QuickAdd extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initVariantSelectors(); // Initialize variant selectors for product options
    if (window.innerWidth <= 798) this.setupMobile(); // Setup mobile-specific behavior
  }

  async checkQuantity(variantID, quantity) {
    this.itemId = variantID;
    this.itemQty = quantity;

    try {
      const response = await fetch('/cart.js'); // Fetch the current cart data
      if (!response.ok) throw new Error('Failed to fetch cart data');

      const cartData = await response.json();
      const cartItem = cartData.items.find((item) => item.id == this.itemId);

      if (cartItem && cartItem.quantity >= this.itemQty) {
        this.displayErrorMessage(cartItem.title); // Display error if quantity exceeds limit
        return false;
      }
      return true;
    } catch (error) {
      console.error('Error checking quantity:', error);
      return false;
    }
  }

  checkAutoRotate() {
    // Toggle auto-rotation for sliders within the current section
    const sectionElement = this.closest('section');
    if (sectionElement) {
      const sliderComponents = sectionElement.querySelectorAll('fx-slider-component');
      sliderComponents.forEach((sliderComponent) => {
        // Ensure only sliders with the 'data-auto-rotate' attribute are toggled
        if (sliderComponent.hasAttribute('data-auto-rotate')) {
          sliderComponent.dataset.autoRotate = sliderComponent.dataset.autoRotate === 'true' ? 'false' : 'true';
        }
      });
    }
  }

  displayErrorMessage(productTitle) {
    // Show an error message for unavailable quantities
    const errorMessage = this.querySelector('.variant-selector__error-message');
    const swatchContainer = this.querySelector('.variant-selector__choices-wrapper');
    const errorMessageContainer = this.querySelector('.variant-selector__choices-wrapper-error_message');

    errorMessageContainer.style.display = 'flex';
    swatchContainer.style.display = 'none';
    errorMessage.innerHTML = `You can't add more ${productTitle} to the cart.`;

    // Revert UI back to normal after 2 seconds
    setTimeout(() => {
      errorMessageContainer.style.display = 'none';
      swatchContainer.style.display = 'flex';
    }, 2000);
  }

  setupMobile() {
    // Setup mobile-specific Quick Add functionality
    const cardMediaElement = this.closest('.card--media');
    const fxCarouselElement =
      this.closest('.fx-carousel-products') ??
      this.closest('.collection') ??
      this.closest('section.fx-complete-look') ??
      this.closest('section.related-products') ??
      this.closest('section.recently-viewed-products');
    this.mobileQuickAddCloseBtn = this.querySelector('.mobile-quick-add-clsBtn');
    this.valueName = this.querySelector('.value-name');

    this.mobileQuickAddBtn = cardMediaElement?.querySelector('.product-quick-add__button') || null;
    this.mobileQuickAddContainer = fxCarouselElement?.querySelector('.mobile-quick-add-container') || null;

    const mobileQuickAddBg = this.mobileQuickAddContainer?.nextElementSibling;
    const bodyElement = document.querySelector('body.gradient');

    if (this.mobileQuickAddBtn && this.mobileQuickAddContainer) {
      this.mobileQuickAddBtn.addEventListener('click', () => {
        this.showMobileQuickAdd(bodyElement, mobileQuickAddBg);
        this.checkAutoRotate();
      });
    }

    this.mobileQuickAddCloseBtn?.addEventListener('click', () => {
      this.hideMobileQuickAdd(bodyElement, mobileQuickAddBg);
      this.checkAutoRotate();
    });

    mobileQuickAddBg?.addEventListener('click', () => this.hideMobileQuickAdd(bodyElement, mobileQuickAddBg));
  }

  showMobileQuickAdd(bodyElement, mobileQuickAddBg) {
    // Display the mobile Quick Add container
    document.querySelectorAll('.mobile-quick-add-container').forEach((container) => container.classList.remove('show'));
    this.mobileQuickAddContainer.innerHTML = this.outerHTML;
    this.mobileQuickAddContainer.classList.add('show');

    if (mobileQuickAddBg) mobileQuickAddBg.style.display = 'block';
    if (bodyElement) bodyElement.classList.add('overflow-hidden');

    const newlyInsertedElement = this.mobileQuickAddContainer.querySelector('quick-add');
    newlyInsertedElement?.classList.remove('is-hidden-mobile');

    const mobileAddCartBtn = this.querySelector('.mobileAddCart');
    mobileAddCartBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      this.checkAutoRotate();
      const variantId = event.target.getAttribute('data-variant-id');
      this.addToCart(variantId, 1, mobileAddCartBtn);
    });
  }

  hideMobileQuickAdd(bodyElement, mobileQuickAddBg) {
    // Hide the mobile Quick Add container
    bodyElement?.classList.remove('overflow-hidden');
    if (mobileQuickAddBg) mobileQuickAddBg.style.display = 'none';
    this.mobileQuickAddContainer?.classList.remove('show');
  }

  initVariantSelectors() {
    // Initialize variant selection functionality
    const productId = this.getAttribute('data-product-id');
    const sizeButtons = this.querySelectorAll('.variant-selector__item');

    sizeButtons.forEach((button) => {
      if (!button.disabled) {
        button.addEventListener('click', async (event) => {
          event.preventDefault();
          const variantId = button.getAttribute('data-variant-id');
          const quantity = button.getAttribute('date-inventory-quantity');

          this.showLoadingState(true, button);
          const canAdd = await this.checkQuantity(variantId, quantity);
          if (canAdd) await this.addToCart(variantId, 1, button);
          this.showLoadingState(false, button);
        });
      }
    });


    this.setupColorSwatches(productId);

  }

  setupColorSwatches(productId) {
    const colorSwatches = this.querySelectorAll(`.swatch[data-product-id="${productId}"]`);
    const variantChoices = this.querySelectorAll('.variant-selector__choice');
    const cardContainer = this.closest('.card--media') || null;
    const current_img = cardContainer?.querySelector('.card__inner .card__media a img') || null;
    const desktop_quick_add_button = this.querySelector('.quick__add.desktop_quick_add_button button') || null;
    const mobileAddCartBtn = this.querySelector('.mobileAddCart') || null;
    let hasSize = false;

    if (desktop_quick_add_button || mobileAddCartBtn) {
      hasSize = true;
    }

    this.valueName = this.querySelector('.value-name') || null;

    let selectedColor = this.getSelectedColor(colorSwatches);
    this.valueName.textContent = selectedColor;

    // Add preloadImage function to preload images
    function preloadImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(src);
        img.onerror = () => reject(src);
        img.src = src;
      });
    }

    // preload images for all color swatches
    const links = Array.from(colorSwatches).map(swatch => swatch.querySelector('span.color-swatch')?.dataset.variantImageLink).filter(Boolean);

    links.forEach(link => {
      preloadImage(link)
        .catch(failed => console.warn(`Preload failed: ${failed}`));
    });

    const updateSizeOptions = () => {
      variantChoices.forEach(choice => {
        choice.style.display =
          choice.getAttribute('data-color') === selectedColor ? 'flex' : 'none';
      });
    };
    updateSizeOptions();

    colorSwatches.forEach(swatch => {
      swatch.addEventListener('click', event => {
        event.preventDefault();
        const span = swatch.querySelector('span.color-swatch');
        const variant_img = span.dataset.variantImageLink;
        const variant_id = swatch.dataset.variantId;
        const variant_inventory = swatch.dataset.variantInventory;

        if (variant_img) {
          current_img.classList.remove('fade-in');

          current_img.onload = () => {
            current_img.classList.add('fade-in');
          }

          setTimeout(() => {
            current_img.src = variant_img;
            current_img.srcset = variant_img;
            current_img.alt = span.getAttribute('data-color-value') || '';
          }, 200);
        }

        if (hasSize) {
          desktop_quick_add_button.setAttribute('data-variant-id', variant_id);
          mobileAddCartBtn.setAttribute('data-variant-id', variant_id);
          desktop_quick_add_button.disabled = (variant_inventory == 0) ? true : false;
          mobileAddCartBtn.disabled = (variant_inventory == 0) ? true : false;


          const labelSpanDesktop = desktop_quick_add_button.querySelector('span');
          const labelSpanMobile = mobileAddCartBtn.querySelector('span');

          if (desktop_quick_add_button.disabled) {
            labelSpanDesktop.innerHTML = 'Sold out';
          } else {
            labelSpanDesktop.innerHTML = 'Add to cart';
          }

          if (mobileAddCartBtn.disabled) {
            labelSpanMobile.innerHTML = 'Sold out';
          } else {
            labelSpanMobile.innerHTML = 'Add to cart';
          }
        }

        colorSwatches.forEach(s => s.classList.remove('selected-color'));
        swatch.classList.add('selected-color');

        selectedColor = swatch.getAttribute('data-color-value');
        this.valueName.textContent = selectedColor;
        updateSizeOptions();

      });
    });
  }

  getSelectedColor(colorSwatches) {
    // Get the currently selected color swatch
    return (
      [...colorSwatches]
        .find((swatch) => swatch.classList.contains('selected-color'))
        ?.getAttribute('data-color-value') || ''
    );
  }

  async addToCart(variantId, quantity, button) {
    // Add the selected variant to the cart
    try {
      const isPreorder = this.dataset.isPreorder === 'true';
      let bodyData = isPreorder ? { id: variantId, quantity, properties: { PreOrder: 'PreOrder' } } : { id: variantId, quantity };

      this.showLoadingState(true, button);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) throw new Error('Failed to add item to cart');
      this.onAddToCartSuccess(button);
    } catch (error) {
      this.onAddToCartError(error, button);
    }
  }

  async onAddToCartSuccess(button) {
    try {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) throw new Error('cart-drawer element not found.');

      await this.updateCartCountAndDrawer(cartDrawer);
      const cartItemCount = await this.updateCartCount();
      document.body.classList.add('overflow-hidden');
      cartDrawer.classList.add('active');
      cartDrawer.classList.remove('is-empty');

      this.updateCartIcon(cartItemCount);
    } catch (error) {
      console.error('Error updating cart drawer and count:', error);
    } finally {
      this.showLoadingState(false, button);
    }
  }

  async updateCartCountAndDrawer(cartDrawer) {
    await Promise.all([this.updateCartCount(), this.refreshCartDrawer(cartDrawer)]);
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.item_count;
    } catch (error) {
      console.error('Error fetching cart:', error);
      return 0;
    }
  }

  async refreshCartDrawer(cartDrawer) {
    try {
      const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
      const responseText = await response.text();
      const updatedCartDrawer = new DOMParser().parseFromString(responseText, 'text/html').querySelector('cart-drawer');
      if (updatedCartDrawer) cartDrawer.innerHTML = updatedCartDrawer.innerHTML;
    } catch (error) {
      console.error('Error fetching updated cart drawer:', error);
    }
  }

  updateCartIcon(quantity) {
    const cartBubble = document.getElementById('cart-icon-bubble');
    if (!cartBubble) {
      console.error('Cart bubble element not found.');
      return;
    }

    let cartCountBubble = cartBubble.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    let cartCountVisuallyHidden = cartBubble.querySelector('.cart-count-bubble span.visually-hidden');

    if (!cartCountBubble) {
      let cartCountBubbleContainer = cartBubble.querySelector('.cart-count-bubble');
      if (!cartCountBubbleContainer) {
        cartCountBubbleContainer = document.createElement('div');
        cartCountBubbleContainer.className = 'cart-count-bubble';
        cartBubble.appendChild(cartCountBubbleContainer);
      }

      cartCountBubble = document.createElement('span');
      cartCountBubble.setAttribute('aria-hidden', 'true');
      cartCountBubbleContainer.appendChild(cartCountBubble);
    }

    if (!cartCountVisuallyHidden) {
      cartCountVisuallyHidden = document.createElement('span');
      cartCountVisuallyHidden.className = 'visually-hidden';
      cartCountBubble.parentElement.appendChild(cartCountVisuallyHidden);
    }

    cartCountBubble.textContent = quantity;
    cartCountVisuallyHidden.textContent = `${quantity} items`;
  }

  onAddToCartError(error, button) {
    console.error('Error adding item to cart:', error);
    this.showLoadingState(false, button);
  }

  showLoadingState(isLoading, button) {
    // Show or hide a loading indicator on the button
    const loadingIconUrl = this.getAttribute('data-loading-icon');
    if (isLoading) {
      button.dataset.originalContent = button.dataset.originalContent || button.innerHTML;
      button.innerHTML = `<img src="${loadingIconUrl}" alt="Loading..." class="loading-spinner" />`;
      button.disabled = true;
    } else {
      button.innerHTML = button.dataset.originalContent;
      button.disabled = false;
    }
  }
}

if (!customElements.get('quick-add')) {
  customElements.define('quick-add', QuickAdd);
}
